export function setDashboard (state, dashboard) {
  Object.keys(dashboard).forEach(key => { state[key] = dashboard[key] })
}

export function setFilters (state, filters) {
  state.filters = filters
}
